<template>
  <v-overlay contained :model-value="model" opacity="0.4"
             class="align-center justify-center rounded">
    <v-progress-circular indeterminate size="56" color="primary"/>
  </v-overlay>
</template>
<script lang="ts">
import {Component, Vue, Prop, toNative} from 'vue-facing-decorator'

/**
 * O cinza que cobre uma janela enquanto ela trabalha.
 *
 * **Tem de ser IRMÃO do card, nunca filho.** `contained` posiciona o overlay por `absolute`
 * contra o ancestral posicionado mais próximo. Dentro do card esse ancestral é o próprio card —
 * que num `v-dialog` é quem ROLA (`.v-dialog > .v-overlay__content > .v-card { overflow-y:
 * auto }`). Aí o bloco de contenção acompanha o conteúdo rolado: o Vuetify tenta compensar
 * somando o `scrollTop` ao `top` (VOverlay.js:307-311), mas o `bottom: 0` continua no fim da
 * área visível, e a cobertura sai curta e deslocada — o cinza torto ao salvar um formulário
 * longo. Como irmão, o ancestral passa a ser o `.v-overlay__content` do diálogo, que não rola e
 * tem o tamanho do card. O `rounded` acompanha o canto de 4px dele, para o cinza não vazar nas
 * quinas.
 *
 * Não serve o overlay do `ontos-base`: o dele tem z-index abaixo do diálogo e ficaria atrás.
 *
 * Existe como peça própria porque duas janelas precisam dele pela mesma razão — o painel de
 * formulário enquanto grava, e a janela da instância enquanto o que ela vai mostrar carrega.
 * Copiá-lo era copiar junto o raciocínio acima, que é a parte que se perde.
 */
@Component({name: 'ontos-busy-overlay'})
class BusyOverlay extends Vue {
  /** Trabalhando? Prop e não slot: é um estado, e a aparência é sempre a mesma. */
  @Prop({type: Boolean, default: false}) readonly model!: boolean
}

export default toNative(BusyOverlay)
</script>
